import { makeAutoObservable, runInAction } from 'mobx';
import { message } from 'antd';

const API_URL = 'https://bitrixapi.tmg-din-reestr.ru'; // адрес бекенда

class CertificateStore {
  certificates = [];
  loading = false;
  user = null;
  auth = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Устанавливаем данные Bitrix
  setUser(user) {
    this.user = user;
  }

  setAuth(auth) {
    this.auth = auth;
  }

  setCertificates(data) {
    this.certificates = data;
  }

  // Геттер для заголовков
  get headers() {
    return {
      'X-Bitrix-User': this.user,
      'X-Bitrix-Auth': this.auth,
      'Content-Type': 'application/json'
    };
  }

  async fetchCertificates() {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/certificates`, {
        headers: this.headers
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const data = await res.json();
      runInAction(() => {
        this.certificates = data.map(c => ({
          ...c,
          employeeName: c.employeeName || `ID ${c.employeeId}`
        }));
      });
      message.success('Сертификаты загружены');
    } catch (e) {
      console.error('Error fetching certificates:', e);
      message.error(`Ошибка загрузки сертификатов: ${e.message}`);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  async updateCertificate(id, data) {
    try {
      const res = await fetch(`${API_URL}/certificates/${id}`, {
        method: 'PUT',
        headers: this.headers,
        body: JSON.stringify(data)
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const updated = await res.json();
      runInAction(() => {
        const index = this.certificates.findIndex(c => c.id === id);
        if (index !== -1) {
          this.certificates[index] = { ...this.certificates[index], ...updated };
        }
      });
      message.success('Сертификат обновлен');
    } catch (e) {
      console.error('Error updating certificate:', e);
      message.error(`Ошибка обновления сертификата: ${e.message}`);
    }
  }

  async addCertificate(data) {
    try {
      const res = await fetch(`${API_URL}/certificates`, {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify(data)
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const newCert = await res.json();
      runInAction(() => {
        this.certificates.push(newCert);
      });
      message.success('Сертификат добавлен');
    } catch (e) {
      console.error('Error adding certificate:', e);
      message.error(`Ошибка добавления сертификата: ${e.message}`);
    }
  }

  async deleteCertificate(id) {
    try {
      const res = await fetch(`${API_URL}/certificates/${id}`, {
        method: 'DELETE',
        headers: this.headers
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      runInAction(() => {
        this.certificates = this.certificates.filter(c => c.id !== id);
      });
      message.success('Сертификат удален');
    } catch (e) {
      console.error('Error deleting certificate:', e);
      message.error(`Ошибка удаления сертификата: ${e.message}`);
    }
  }

  async removeFileFromCertificate(id, fileUrl) {
    const cert = this.certificates.find(c => c.id === id);
    if (!cert) return;
    const updatedFiles = (cert.files || []).filter(url => url !== fileUrl);
    try {
      await this.updateCertificate(id, { files: updatedFiles });
      message.success('Файл удален из сертификата');
    } catch (e) {
      message.error(`Ошибка удаления файла: ${e.message}`);
    }
  }
}

const certificateStore = new CertificateStore();
export default certificateStore;
